//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('productPrices', {
//        templateUrl: 'views/components/views/productPrices/productPrices.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'ieScreenBlockService', 'productPricesService', 'logisticService', function ($stateParams, stateService, utilityService, ieScreenBlockService, productPricesService, logisticService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let prodId = $stateParams.prod_id;
            
//            vm.model = {
//                bgPriceType: {
//                    selected: 'PRICELIST',
//                    buttons: [
//                        { id: 'PRICELIST', label: 'productprices_pricelists', color: 'primary', onClick: () => vm.model.bgPriceType.selected = 'PRICELIST' },
//                        { id: 'PURCHPRICE', label: 'productprices_purchprice', color: 'primary', onClick: () => vm.model.bgPriceType.selected = 'PURCHPRICE' }
//                    ]
//                },
//                priceGroupButtons: [
//                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('colorgrps') }
//                ],
//                setting: {},
//                selectListProductSizes: [],
//                selectListPriceGroups: [],
//                itemsListRelatedToPriceGroups: [],
//                itemsListRelatedToProductSizes: [],
//                approving: false,
//                rollbacking: false,
//                refreshingPriceGroups: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await productPricesService.getSetting({ prod_id: prodId }))[0];
//            }
            
//            async function loadProductSizes() {
//                vm.model.selectListProductSizes = await logisticService.listProductSizes({ prod_id: prodId });
//            }
            
//            async function loadPriceGroups() {
//                if (utilityService.validateParmsValue(vm.model.setting.prodsize_keyno) !== true) return;

//                vm.model.selectListPriceGroups = await productPricesService.listPriceGroups({ prodsize_keyno: vm.model.setting.prodsize_keyno });
//            }
            
//            async function loadRelatedToPriceGroups() {
//                if (utilityService.validateParmsValue(vm.model.setting.pricegrp_keyno, true) !== true) return;

//                return productPricesService.listRelatedToPriceGroups(vm.model.setting).then((list) => {
//                    ieScreenBlockService.stop();
//                    vm.model.itemsListRelatedToPriceGroups = list;
//                });
//            }
            
//            async function loadRelatedToProductSizes() {
//                if (utilityService.validateParmsValue(vm.model.setting.prodsize_keyno) !== true) return;

//                return productPricesService.listRelatedToProductSizes(vm.model.setting).then((list) => {
//                    ieScreenBlockService.stop();
//                    vm.model.itemsListRelatedToProductSizes = list;
//                });
//            }

//            function retrieveProductPriceSettings() {
//                if (utilityService.validateParmsValue(vm.model.setting.prodsize_keyno) !== true) return;

//                return productPricesService.getProductPriceSettings({ prodsize_keyno: vm.model.setting.prodsize_keyno }).then((response) => {
//                    vm.model.setting.pricegrp_keyno = response[0].pricegrp_keyno;

//                    if (vm.model.setting.pricegrp_keyno !== '') loadPriceGroups();
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON GROUP SINGLE FUNCTION

//            vm.selectBgPriceType = function (value) {
//                vm.model.bgPriceType.selected = value;
//            };

//            // #endregion BUTTON GROUP SINGLE FUNCTION

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'prodsize_keyno':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.prodsize_keyno) !== true) return;

//                        vm.model.setting.prodsize_keyno = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.prodsize_keyno) !== true) return;

//                        Promise.all([
//                            ieScreenBlockService.start('message'),
//                            retrieveProductPriceSettings()
//                        ]).then(() => {
//                            loadRelatedToProductSizes();
//                            loadRelatedToPriceGroups();

//                            Promise.resolve();
//                        });
//                        break;
//                    case 'pricegrp_keyno':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.pricegrp_keyno) !== true) return;

//                        vm.model.setting.pricegrp_keyno = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.pricegrp_keyno, true) !== true) return;

//                        ieScreenBlockService.start('message');

//                        loadRelatedToPriceGroups();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region APPROVE & ROLLBACK BUTTON FUNCTIONS

//            vm.approveChanges = function () {
//                vm.model.approving = true;

//                productPricesService.setActivePrice({
//                    way: 'APPROVE',
//                    listitems: vm.model.itemsListRelatedToPriceGroups
//                }).then(() => {
//                    vm.model.approving = false;

//                    ieScreenBlockService.start('message');
//                    loadRelatedToPriceGroups();
//                });
//            };
            
//            vm.rollbackChanges = function () {
//                vm.model.rollbacking = true;

//                productPricesService.setActivePrice({
//                    way: 'ROLLBACK',
//                    listitems: vm.model.itemsListRelatedToPriceGroups
//                }).then(() => {
//                    vm.model.rollbacking = false;

//                    ieScreenBlockService.start('message');
//                    loadRelatedToPriceGroups();
//                });
//            };

//            // #endregion APPROVE & ROLLBACK BUTTON FUNCTIONS

//            // #region BUTTON REFRESH PROCEDURE FUNCTION CALL

//            vm.refreshPriceGroupsChanges = function () {
//                vm.model.refreshingPriceGroups = true;

//                productPricesService.refreshItems(vm.model.setting).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: (dialogItself) => {
//                    				dialogItself.close();
//                                    vm.model.refreshingPriceGroups = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                        vm.model.refreshingPriceGroups = false;

//                        loadSetting();
//                    }
//                });
//            }

//            // #endregion BUTTON REFRESH PROCEDURE FUNCTION CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'price':
//                        go({
//                            pricegrp_keyno: vm.model.setting.pricegrp_keyno,
//                            price_keyno: '0'
//                        });
//                        break;
//                    case 'purchprice':
//                        go({
//                            prodsize_keyno: vm.model.setting.prodsize_keyno,
//                            purchprice_keyno: '0'
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadProductSizes();

//                Promise.all([
//                    loadPriceGroups()
//                ]).then(() => {
//                    loadRelatedToPriceGroups();
//                    loadRelatedToProductSizes();

//                    Promise.resolve();
//                });
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
